import React, {Component} from 'react'
import Tile from '../tags/Tile'
import {deleteFavouritedTile, getFavouritedTiles, getReservoirApiUrl} from '../../services/vu'
import {getTileByUuid} from '../../services/reservoir'
import { Home, StarBorder } from '@mui/icons-material'
import {Link} from 'react-router-dom'
import {getSortedTiles} from '../../helpers/tile'
import Loading from '../tags/Loading'
import { getProperty } from '../../helpers/properties';
import {connect} from 'react-redux'
import {getConfiguration} from "../../helpers/configuration";

const mapStateToProps = ({page: {title}}) => {
  return {
    title,
  }
}

class Favourites extends Component {
  constructor (props) {
    super(props)

    this.state = {
      tiles: [],
      tileTypes: [],
      tileImages: [],
      reservoirApiUrl: '/',
      loadingTiles: true,
    }
  }

  componentDidMount() {
    getReservoirApiUrl().then(reservoirApiUrl => {
      this.setState({
        reservoirApiUrl: reservoirApiUrl,
      }, () => {
        this.loadFavouritedTiles()
      })
    })
  }

  loadFavouritedTiles = () => {
    getFavouritedTiles()
      .then(favouritedTiles => favouritedTiles.map(favouritedTile => getTileByUuid(favouritedTile)))
      .then(favouriteTilesToRequest => Promise.all(favouriteTilesToRequest))
      .then(favouritedTiles => favouritedTiles.filter(favouritedTile => !!favouritedTile))
      .then(favouritedTiles => {
        this.setState({
          tiles: favouritedTiles,
          loadingTiles: false,
        })
      })
  }

  handleFavouriteButtonClick = tileId => {
    deleteFavouritedTile(tileId).then(() => {
      this.loadFavouritedTiles()
    })
  }

  getCategory = categoryUuid => {
    const category = this.getTileIncludes().find(category => category.id === categoryUuid)

    return category && category.attributes && category.attributes.name
  }

  getImage = imageId => {
    const image = this.getTileIncludes().find(image => image.id === imageId)
    //VUS-157 Tiles' background image are missing
    return image && image.attributes && image.attributes.uri.url && `${this.state.reservoirApiUrl}${image.attributes.uri.url}`
  }

  getTileIncludes = () => {
    return this.state.tiles
      .map(tile => tile.included)
      .filter(includes => !!includes)
      .reduce((accumulator, currentValue) => accumulator.concat(currentValue), [])
  }

  getTileData = () => this.state.tiles.map(tile => tile.data)

  render() {
    return (
      <div className="page">
        <div className="row">
          <div className='col-xs-12 col-md-offset-2 col-md-8'>
            {this.state.loadingTiles ? (
              <section className='tile-container'>
                <Loading message="Loading your favourite tiles..."/>
              </section>
            ) : (
              <section className='tile-container'>
                <div className="row">
                  {this.getTileData().length > 0 ? getSortedTiles(this.getTileData()).map((tile, index) => {
                    const tileAttributes = tile.attributes;
                    const tileRelationships = tile.relationships
                    const categoryUuid = tileRelationships && tileRelationships.field_tile_type && tileRelationships.field_tile_type.data && tileRelationships.field_tile_type.data[0] && tileRelationships.field_tile_type.data[0].id
                    const category = this.getCategory(categoryUuid)
                    const imageId = tileRelationships && tileRelationships.field_photo && tileRelationships.field_photo.data && tileRelationships.field_photo.data.id
                    const image = this.getImage(imageId)

                    return (
                      <Tile
                        key={tile.id}
                        position={index}
                        context={this.props.title}
                        tileId={tile.id}
                        link={tileAttributes.field_link_to_video && tileAttributes.field_link_to_video.uri}
                        imageUrl={image}
                        video={tileAttributes.field_is_video_}
                        category={category}
                        title={tileAttributes.field_heading}
                        description={tileAttributes.field_description}
                        favourited={true}
                        onFavourite={tileId => this.handleFavouriteButtonClick(tileId)}
                        tileSize={parseInt(tileAttributes.field_size)}
                      />
                    )
                  }) : (
                    <div className="col-xs-12">
                      <div className="empty-state-container empty-state-container--favourites">
                        <div className="icon"/>
                        <h2>You don't have anything in your Favourites.</h2>
                        <p>Find something you like at <Link to={getConfiguration('baseUrl')} className="txt-link"><Home/></Link> and select the <StarBorder className="btn-point-events"/> to add to your Favourites.</p>
                      </div>
                    </div>
                  )}
                </div>
              </section>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Favourites)
